import * as React from 'react'
import FileCollaborationTool from './file_collaboration_tool'


export default function FileCollaborationToolApp(props) {
  return <FileCollaborationTool {...props} />
}